"use strict";

exports.__esModule = true;
exports.default = void 0;
var _helpers = require("../../helpers");
var _WebRequestHelper = require("../../helpers/WebRequestHelper");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CancelToken = _axios.default.CancelToken;

//const translationActions = new ActionHelper({ singular: 'translationentry', plural: 'translationentries' });

class Actions extends _helpers.ActionHelper {
  constructor() {
    super({
      singular: "translationentry",
      plural: "translationentries"
    });
    _defineProperty(this, "init", data => {
      return dispatch => {
        dispatch({
          type: "INIT_TRANSLATIONENTRIES",
          data: data
        });
      };
    });
    //getAll = (params, module) => translationActions.getAll(params, this);
    _defineProperty(this, "getAllTranslationEntries", (languageSelected, params, module, useAuthentication = true, cancelPreviousRequests = true) => {
      params = {
        expand: "Language",
        filter: `LanguageId != null and LanguageId.Equals("${languageSelected.Id}")`,
        limit: 2000,
        orderBy: ""
      };
      if (this.source !== undefined && cancelPreviousRequests === true) {
        this.source.cancel();
      }
      this.source = CancelToken.source();
      return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
        request.method = "get";
        request.url = `${this._uri}${(0, _helpers.paramsToString)(params)}`;
        request.cancelToken = this.source.token;
        return (0, _WebRequestHelper.sendRequest)(request).then(response => {
          return response.data;
        }).catch(error => {
          if (_axios.default.isCancel(error)) {
            //console.log('Request canceled');
          } else {
            console.dir(error);
          }
        });
      }).catch(err => console.log(err));
    });
    _defineProperty(this, "mergeSchema", (dataFromServer, column) => {
      column === "LanguageFrom" ? dataFromServer.map(field => {
        field.LanguageFrom = field.Value;
        field.LanguageTo = "";
      }) : dataFromServer.map(field => {
        field.LanguageTo = field.Value;
      });
      return dataFromServer;
    });
  }
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;